import React, { useState, useContext } from 'react';
import './Profile.scss';
import PublicImage from 'src/common/components/PublicImage';
import { layoutContext } from '../../CloudPakForAiops';
import { Scenario } from '../../../data/constants';

const Profile = ({ copy }: any) => {
  copy = copy.steps.profile;

  const { setProfile } = useContext(layoutContext);
  const { setCurrentScenario } = useContext(layoutContext);

  const [selectedOption, setSelectedOption] = useState(''); // State to store the selected option

  const handleOptionChange = (event: any) => {
    setSelectedOption(event.target.value); // Update the selected option when the input value changes
  };

  const getRoleDescription = () => {
    if (selectedOption === 'sre') {
      return (
        <>
          <br />
          <p>{copy.items[0].copy}</p>
        </>
      );
    } else if (selectedOption === 'admin') {
      return (
        <>
          <br />
          <p>
            <p>{copy.items[1].copy}</p>
          </p>
        </>
      );
    }
  };

  return (
    <>
      <div className="cloud-pak-for-aiops_profile-modal-wrapper">
        <h3>{copy.title}</h3>
        <br />
        <p>{copy.description}</p>
        <br />
        <div className="cloud-pak-for-aiops_profile-modal-select">
          <label>
            <input
              type="radio"
              name="options"
              value="sre"
              className="cloud-pak-for-aiops_profile-modal-select-input"
              checked={selectedOption === 'sre'}
              onChange={handleOptionChange}
            />
            <div className="cloud-pak-for-aiops_profile-modal-select-option">
              <PublicImage
                imgPath={
                  selectedOption === 'sre'
                    ? copy.items[0].image.srcSelected
                    : copy.items[0].image.src
                }
                widgetId="cloud-pak-for-aiops"
                alt={copy.items[0].image.alt}
              />
              <span>
                <strong>{copy.items[0].title}</strong>
                <br />
                {copy.items[0].role}
              </span>
            </div>
          </label>
          <label>
            <input
              type="radio"
              name="options"
              value="admin"
              className="cloud-pak-for-aiops_profile-modal-select-input"
              checked={selectedOption === 'admin'}
              onChange={handleOptionChange}
            />
            <div className="cloud-pak-for-aiops_profile-modal-select-option">
              <PublicImage
                imgPath={
                  selectedOption === 'admin'
                    ? copy.items[1].image.srcSelected
                    : copy.items[1].image.src
                }
                widgetId="cloud-pak-for-aiops"
                alt={copy.items[1].image.alt}
              />
              <span>
                <strong>{copy.items[1].title}</strong>
                <br />
                {copy.items[1].role}
              </span>
            </div>
          </label>
        </div>
        {getRoleDescription()}

        <button
          className="cloud-pak-for-aiops_profile-modal-cta"
          disabled={selectedOption !== '' ? false : true}
          onClick={() => {
            if (selectedOption !== '') {
              setProfile(selectedOption);
              setCurrentScenario(Scenario.sidebar);
            }
          }}
        >
          {copy.cta}
        </button>
      </div>
    </>
  );
};

export default Profile;
